import { useGenericModal } from '..';
import {
  DeleteSolutionModal,
  DeleteSolutionModalProps,
} from './delete-solution-modal';

export const useDeleteSolutionModal = (
  props?: Partial<DeleteSolutionModalProps>
) => {
  const { modalRef, openModal, closeModal } = useGenericModal();

  const modalComponent = (
    <DeleteSolutionModal
      testId={props?.testId}
      modalRef={modalRef}
      onClose={closeModal}
      onClosed={props?.onClosed}
      preferOpenFailure={props?.preferOpenFailure}
    />
  );

  return {
    modalRef,
    openModal,
    closeModal,
    deleteSolutionModal: modalComponent,
  };
};
